module.exports = __webpack_public_path__ + "static/media/gdsclogo.ca3c82fc.svg";